import { Link } from 'react-router-dom';

interface Area {
  id: string;
  name: string;
  slug: string;
}

interface AreaNavBarProps {
  areas: Area[];
  townSlug: string;
  currentAreaSlug?: string;
  isPreview?: boolean;
}

export function AreaNavBar({ areas, townSlug, currentAreaSlug, isPreview }: AreaNavBarProps) {
  if (areas.length === 0) return null;

  return (
    <nav className="bg-muted border-b border-border">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-wrap items-center justify-center gap-1 py-2">
          {areas.map((area) => {
            const isActive = area.slug === currentAreaSlug;
            return (
              <Link
                key={area.id}
                to={`/${townSlug}/${area.slug}${isPreview ? '?preview=true' : ''}`}
                className={`
                  px-3 py-1.5 text-xs rounded-md transition-colors uppercase tracking-wide
                  ${isActive 
                    ? 'bg-primary text-primary-foreground font-medium' 
                    : 'text-foreground hover:bg-muted hover:text-foreground'
                  }
                `}
              >
                {area.name}
              </Link>
            );
          })}
        </div>
      </div>
    </nav>
  );
}
